import type { MutableRefObject } from 'react';

import type { ConnectorMap } from '../../../renderers/connector/connectorRenderer';
import type { ActionNode } from '../../../renderers/node/actionNodeComponent';
import type { Node } from '../../../renderers/node/nodeComponent';
import type { NodeMap } from '../../../renderers/node/nodeRenderer';
import type { Connection } from '../../../types/connection';
import type { Relation } from '../../../types/relation';

export const updateRelayedConnector = (
  id: Connection['id'],
  partialUpdatedConnection: Partial<Connection>,
  relayedConnectorsRef: MutableRefObject<ConnectorMap>,
): void => {
  const relayedConnector = relayedConnectorsRef.current[id];

  if (!relayedConnector) {
    return;
  }

  relayedConnector.redraw({
    ...relayedConnector.props,
    ...partialUpdatedConnection,
  });
};

export const updateRelayedNode = (
  id: Relation['id'],
  partialUpdatedNode: Partial<Relation>,
  relayedNodesRef: MutableRefObject<NodeMap<Node | ActionNode>>,
): void => {
  const relayedNode = relayedNodesRef.current[id] as Node;

  if (!relayedNode) {
    return;
  }

  relayedNode.redraw({
    ...relayedNode.props,
    node: {
      ...relayedNode.props.node,
      ...partialUpdatedNode,
    },
  });
};
